import type { IPrizeDropData } from '../../../api/fetchers/promotions/types';
import type { CoreStoreType } from '../../../store/CoreStore';
import { promotionActions } from '../../../store/slices/promotions/slice';
import type { GameCommunicationMessageType, IGameCommunicationProcessor } from '../types';

export interface PrizeDropWinMessage extends GameCommunicationMessageType {
  amount: string;
  beforeInit: boolean;
  bet: string;
  delay: number;
  id: string;
  mul: string;
  pdid: string;
  prizeType: 'C' | 'G';
  seq: number;
  table: string;
  textPrize: string;
  transId: string;
  userId: string;
  wiid: string;
}

export class GameCommunicationPromotionsProcessor implements IGameCommunicationProcessor {
  messageName = 'prizedrop_win';

  process(message: PrizeDropWinMessage, store: CoreStoreType): void {
    console.log('[PROMO] ', message);
    // ToDo: WTF?
    const modified = store.getState().promotions.prizeDrops.find((pd) => pd.pdid == Number(message.pdid));

    const promo = Object.assign({}, message, {
      nm: modified?.PRIZEDROP.nm,
      PRIZEDROP: modified?.PRIZEDROP,
      PRIZEDROP_DETAILS: modified?.PRIZEDROP_DETAILS,
    });

    store.dispatch(promotionActions.setWinPopup(promo as unknown as IPrizeDropData));
  }
}
